import React, { useEffect, useState } from "react";
import {
    employeeImportHeaders,
    isString,
    isNumber,
    isEmail,
    normalizeGender,
} from "./employeeImportValidators";
import { makeStyles } from "@material-ui/core/styles";
import readXlsxFile from "read-excel-file";
import theme from "../../theme";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import CommonButton from "../../components/button";
import CommonFormDropDown from "../formdropdown";
import InfoIcon from "@material-ui/icons/Info";
import { getAdminWithdrawalCategoriesAction } from "../../containers/companyDashboard/action";
import { useDispatch, useSelector } from "react-redux";




let fileDownloader;
let fileUploader;

let companyOptions = [];
const headers = employeeImportHeaders;
const info = {
    "Default": "Applies Company General Limits To Employees",
    "Level 1": "Applies 20 % Withdrawal Limit To Employees",
    "Level 2": "Applies 45 % Withdrawal Limit To Employees",
    "Level 3": "Applies 70 % Withdrawal Limit To Employees",
    "Level 4": "Applies 100 % Withdrawal Limit To Employees",
}


const useStyles = makeStyles(() => ({
    root: { display: "flex", justifyContent: "center", padding: "30px 0px", width: "100%" },
    container: {
        width: "350px",
        backgroundColor: theme.colors.White,
        boxShadow: "0px 0px 10px #CFD9EA80",
        borderRadius: "15px",
        padding: "50px 60px",
    },
    title: { color: theme.colors.DodgerBlue, fontSize: "24px", fontFamily: theme.fontFamily.MARKPROBOLD, marginBottom: "20px" },
    subText: { color: theme.colors.Violet, fontSize: "18px", fontFamily: theme.fontFamily.MARKPRO, marginBottom: "10px" },
    fileContainer: { backgroundColor: theme.colors.Zumthor, padding: "5px 10px", top: "15px", position: "relative", borderRadius: "3px", wordBreak: "break-word" },
    fileName: { color: theme.colors.DodgerBlue, fontSize: "14px", fontFamily: theme.fontFamily.MARKPROMEDIUM },
    crossIcon: { marginLeft: "8px", marginBottom: "-4px", cursor: "pointer" },
    modal: { display: "flex", alignItems: "center", justifyContent: "center" },
    paper: { position: "absolute", width: 400, backgroundColor: "#fff", border: "2px solid #000", boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.5)", padding: 20 },
    validationModalPaper: {
        position: "absolute",
        width: "min(920px, 92vw)",
        maxHeight: "85vh",
        backgroundColor: "#fff",
        boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.35)",
        borderRadius: "10px",
        padding: "18px 20px",
        overflowY: "auto",
    },
    validationModalTitle: {
        color: theme.colors.Violet,
        fontSize: "18px",
        fontFamily: theme.fontFamily.MARKPROBOLD,
        marginBottom: "8px",
    },
    validationModalSubText: {
        color: theme.colors.DodgerBlue,
        fontFamily: theme.fontFamily.MARKPRO,
        marginBottom: "14px",
    },
    validationModalFooter: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "14px",
    },
    buttonContainer: { display: "flex", justifyContent: "space-between" },
    successText: { color: "#0f9d58", fontFamily: theme.fontFamily.MARKPROMEDIUM, marginTop: "20px" },
    switcherRow: {
        display: "flex",
        justifyContent: "center",
        marginBottom: "24px",
    },
    columnStack: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "24px",
        width: "100%",
    },
    containerWide: {
        maxWidth: "700px",
        minWidth: "700px",
        boxSizing: "border-box",
        "@media (max-width: 600px)": {
            borderRadius: "10px",
        },
    },

}));

const pushOnce = (errors, message) => {
    if (errors.indexOf(message) < 0) errors.push(message);
};

const validateData = (rows) => {
    const mappedRows = [];
    const errors = [];

    if (!rows || rows.length <= 1) {
        pushOnce(errors, "No data found.");
        return { errors, hasDataRows: false };
    }

    for (let i = 1; i < rows.length; i++) {
        const entry = {};
        for (let j = 0; j < headers.length; j++) entry[headers[j]] = rows[i][j];
        mappedRows.push(entry);
    }

    mappedRows.forEach((element) => {
        if (!element["First Name"] || !element["First Name"]?.trim()) pushOnce(errors, "First Name may not be blank.");
        else if (element["First Name"]?.trim().length > 24) pushOnce(errors, "Ensure First Name has no more than 24 characters.");
        else if (!element["First Name"]?.trim().toString().match(isString)) pushOnce(errors, "First Name should contain only letters and spaces. Numbers and special characters are not allowed.");

        if (!element["Last Name"] || !element["Last Name"]?.trim()) pushOnce(errors, "Last Name may not be blank.");
        else if (element["Last Name"]?.trim().length > 24) pushOnce(errors, "Ensure Last Name has no more than 24 characters.");
        else if (!element["Last Name"]?.trim().toString?.()?.match?.(isString)) pushOnce(errors, "Last Name should contain only letters and spaces. Numbers and special characters are not allowed.");

        if (!element["Gender"] || !element["Gender"]?.trim()) pushOnce(errors, "Gender may not be blank.");
        else {
            const normalizedGender = normalizeGender(element["Gender"]);
            if (normalizedGender !== "M" && normalizedGender !== "F") pushOnce(errors, "Gender should be M/F, Male/Female, or male/female.");
        }

        if (!element["Email"] || !element["Email"]?.trim()) pushOnce(errors, "Email may not be blank.");
        else if (!element["Email"]?.trim().toString?.()?.match?.(isEmail)) pushOnce(errors, "Email should be in proper format.");

        if (!element["Phone number"] || (element["Phone number"] && !Number.toString(element["Phone number"]).trim())) pushOnce(errors, "Phone number may not be blank.");

        if (!element["Title"] || !element["Title"]?.trim()) pushOnce(errors, "Job Title may not be blank.");
        else if (element["Title"]?.trim().length > 24) pushOnce(errors, "Ensure Job Title has no more than 24 characters.");
        else if (!element["Title"]?.trim().toString?.()?.match?.(isString)) pushOnce(errors, "Job Title should contain only letters and spaces. Numbers and special characters are not allowed.");

        if (!element["Full Net Salary"]) pushOnce(errors, "Full Salary may not be blank.");
        else if (!element["Full Net Salary"]?.toString?.()?.match?.(isNumber)) pushOnce(errors, "Full Salary should contain only numbers and decimal point. Letters and special characters (except decimal point) are not allowed.");

        if (!element["Savings"]) pushOnce(errors, "Savings may not be blank.");
        else if (!element["Savings"]?.toString?.()?.match?.(isNumber)) pushOnce(errors, "Savings should be number only.");
        else if (element["Full Net Salary"] && element["Savings"] >= element["Full Net Salary"]) pushOnce(errors, "Savings should be less than Full Salary.");

        if (!element["Account holder name"] || !element["Account holder name"]?.trim()) pushOnce(errors, "Account Holder Name may not be blank.");
        else if (element["Account holder name"]?.trim()?.length > 80) pushOnce(errors, "Ensure Account Holder Name has no more than 80 characters.");
        else if (!element["Account holder name"]?.trim()?.toString()?.match(isString)) pushOnce(errors, "Account holder name should contain only letters and spaces. Numbers and special characters are not allowed.");

        if (!element["Bank Name"] || !element["Bank Name"]?.trim()) pushOnce(errors, "Bank Name may not be blank.");
        else if (element["Bank Name"]?.trim().length > 48) pushOnce(errors, "Ensure Bank Name has no more than 48 characters.");
        else if (!element["Bank Name"]?.trim().toString?.()?.match?.(isString)) pushOnce(errors, "Bank Name should contain only letters and spaces. Numbers and special characters are not allowed.");

        if (!element["Bank Code"] || !element["Bank Code"]?.toString()?.trim()) pushOnce(errors, "Bank Code may not be blank.");
        else if (element["Bank Code"]?.toString()?.trim().length > 6) pushOnce(errors, "Ensure Bank Code has no more than 6 characters.");

        if (!element["Account number"]) pushOnce(errors, "Account Number may not be blank.");
        else if (element["Account number"]?.length > 255) pushOnce(errors, "Ensure Account number has no more than 255 characters.");
        else if (!element["Account number"]?.toString?.()?.match?.(isNumber)) pushOnce(errors, "Account number should be number only.");

        if (element["NIN"] && element["NIN"].toString().length !== 11) pushOnce(errors, "NIN should Be Eleven digits");
        if (element["BVN"] && element["BVN"].toString().length !== 11) pushOnce(errors, "BVN should Be Eleven digits");
    });

    return { errors, hasDataRows: true };
};

export default function EmployeeSheetProcessor({
    title = "",
    onValidUpload,
    onSubmit,
    onFileClose,
    hasErrors = false,
    loading = false,
    // Commit (onboard) capability. When false, validation still runs but the
    // final Submit button stays disabled (needs employee_upload.create).
    canCommit = true,
}) {
    const classes = useStyles();

    const [file, setFile] = useState(null);
    const [errors, setErrors] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isParsingFile, setIsParsingFile] = useState(false);
    const [isValidFile, setIsValidFile] = useState(false);
    const [apiValidationErrors, setApiValidationErrors] = useState(null);
    const [isApiErrorModalOpen, setIsApiErrorModalOpen] = useState(false);
    const [employeesMapped, setEmployeesMapped] = useState([]);
    const [limitCategories, setLimitCategories] = useState([]);
    const [level, setLevel] = useState({ label: "Default", value: "0" });

    const dispatch = useDispatch();
    const companyDashboardReducer = useSelector((state) => state.companyDashboardReducer);
    const dashboardReducer = useSelector((state) => state.dashboardReducer);

    const getAdminWithdrawalCategoriesActionMethod = React.useCallback(
        (filters) => (dispatch(getAdminWithdrawalCategoriesAction(filters))), [dispatch]);

    const mapRowsToEmployees = (rows) => {
        const mappedRows = [];
        for (let i = 1; i < rows.length; i++) {
            const entry = {};
            for (let j = 0; j < headers.length; j++) entry[headers[j]] = rows[i][j];
            mappedRows.push(entry);
        }

        return mappedRows.map((each) => ({
            email: each["Email"] && each["Email"]?.trim(),
            first_name: each["First Name"] && each["First Name"]?.trim(),
            last_name: each["Last Name"] && each["Last Name"]?.trim(),
            gender: each["Gender"] ? normalizeGender(each["Gender"]) : null,
            branch: each["Office Location"] && each["Office Location"]?.trim(),
            employee_id: each["Employee ID"] && each["Employee ID"]?.toString()?.trim(),
            bank: {
                account_holder: each["Account holder name"] && each["Account holder name"]?.trim(),
                name: each["Bank Name"] && each["Bank Name"]?.trim(),
                code: each["Bank Code"] && each["Bank Code"]?.toString()?.trim(),
                number: each["Account number"],
                iban: (each["IBAN(optional)"] && each["IBAN(optional)"].toString().trim()) || null,
            },
            withdrawal_percent: level.value,
            profile: {
                position: each["Title"] && each["Title"].trim(),
                phone: each["Phone number"],
                salary: each["Full Net Salary"],
                savings: each["Savings"],
                nin: each["NIN"] && each["NIN"]?.toString(),
                bvn: each["BVN"] && each["BVN"]?.toString(),
            },
        }));
    };
    useEffect(() => {
        getAdminWithdrawalCategoriesActionMethod({ history: 1 })
      }, [])
    

    useEffect(() => {
        const { withdrawalLimitCategories } = companyDashboardReducer;

        if (Array.isArray(withdrawalLimitCategories?.data)) {
            let arr = []
            withdrawalLimitCategories.data.forEach((value) => {
                arr.push({ label: value.name, value: value.limit })
                info[value.name] = value.description
            })
            setLimitCategories(arr);
        }
    }, [companyDashboardReducer?.withdrawalLimitCategories])

    useEffect(() => {
        if (JSON.parse(localStorage.getItem("user"))?.is_super) {
            let arr2 = []
            const { withdrawalLimitCategories } = dashboardReducer;
            if (Array.isArray(withdrawalLimitCategories)) {
                withdrawalLimitCategories.forEach((value) => {
                    arr2.push({ label: value.name, value: value.limit })
                    info[value.name] = value.description
                })
                setLimitCategories(arr2)
            }
        }
    }, [dashboardReducer])

    return <div className={classes.container}>

        <div className={classes.title}>{title || "Upload Employees Sheet"}</div>
        {onSubmit && <div className={classes.subText}>
            <CommonFormDropDown
                label="Percentage Withdrawal Limit Level To Apply To Employees"
                placeholder={"Select Level"}
                disabled={file ? true : false}
                options={[
                    { label: "Default", value: "0" },
                    ...limitCategories
                ]}
                value={level}
                onChange={(val) => {
                    setLevel(val);
                }}
                isSearchable={false}
                isDisabled={
                    companyDashboardReducer?.loading
                    || companyDashboardReducer.withdrawalLimitCategoriesLoading || dashboardReducer.loading
                }
                error={false}
                helperText={""}
                isLoading={
                    companyDashboardReducer?.loading
                    || companyDashboardReducer.withdrawalLimitCategoriesLoading || dashboardReducer.loading
                }
            />
            <p
                style={{ fontSize: "0.875rem", color: "#666", flexDirection: "row", alignItems: "center", display: "flex" }}
            >
                <InfoIcon className={classes.infoIco} /> {info[level.label]}
            </p>
        </div>}
        <div className={classes.subText}>Download our template to validate employee data format.</div>
        <div style={{ marginBottom: "40px" }}>
            <CommonButton stylevariant="secondary2" type="button" text={"Download Template"} onClick={() => fileDownloader.click()} icon={"/images/download.png"} />
            <a ref={(ref) => { fileDownloader = ref; }} href={"/Employees template list.xlsx"} download={"Employees template list"} style={{ display: "none" }}>download</a>
        </div>
        <div className={classes.subText}>Upload a completed sheet to see validation errors.</div>
        <div style={{ marginBottom: "40px" }}>
            <CommonButton stylevariant="secondary2" type="button" text={"Upload Employee Sheets"} onClick={() => setShowModal(true)} icon={"/images/upload.png"} />
            <Modal open={showModal} onClose={() => setShowModal(false)} className={classes.modal}>
                <div className={classes.paper}>
                    <p>This action cannot be revoked. Are you sure you want to proceed?</p>
                    <div className={classes.buttonContainer}>
                        <Button variant="contained" style={{ backgroundColor: "#3E83FA" }} onClick={() => { fileUploader.click(); setShowModal(false); }}>Yes, Proceed</Button>
                        <Button variant="contained" style={{ backgroundColor: "#FF3B59" }} onClick={() => setShowModal(false)}>Cancel</Button>
                    </div>
                </div>
            </Modal>
            <input
                type="file"
                ref={(ref) => { fileUploader = ref; }}
                style={{ display: "none" }}
                onClick={(event) => { event.target.value = null; }}
                onChange={(e) => {
                    const uploadedFile = e.target.files[0];
                    setFile(uploadedFile || null);
                    setIsValidFile(false);
                    setErrors([]);
                    setApiValidationErrors(null);
                    setIsApiErrorModalOpen(false);
                    if (!uploadedFile) return;
                    setIsParsingFile(true);
                    readXlsxFile(uploadedFile)
                        .then((rows) => {
                            const { errors: nextErrors, hasDataRows } = validateData(rows);
                            setErrors(nextErrors);
                            if (hasDataRows) {
                                const mappedEmployees = mapRowsToEmployees(rows);
                                if (mappedEmployees.length) {
                                    onValidUpload?.(mappedEmployees);
                                    setEmployeesMapped(mappedEmployees);
                                } else {
                                    setIsValidFile(false);
                                    setEmployeesMapped([]);
                                }
                            } else {
                                setIsValidFile(false);
                                setEmployeesMapped([]);
                            }
                        })
                        .catch(() => {
                            setErrors(["Unable to read the uploaded file. Please upload a valid .xlsx file."]);
                            setIsValidFile(false);
                            setFile(null);
                            setEmployeesMapped([]);
                        })
                        .finally(() => setIsParsingFile(false));
                }}
                accept=".xlsx"
            />
            {file?.name ? (
                <span className={classes.fileContainer}>
                    <span className={classes.fileName}>{file.name}</span>
                    <img
                        src={"/images/cross.png"}
                        alt="cross"
                        className={classes.crossIcon}
                        onClick={() => {
                            onFileClose?.();
                            setFile(null);
                            setErrors([]);
                            setIsValidFile(false);
                            setApiValidationErrors(null);
                            setIsApiErrorModalOpen(false);
                            setEmployeesMapped([]);
                        }}
                    />
                </span>
            ) : null}
            {errors.length ? (
                <div className={"error-container"} style={{ marginTop: "4px" }}>
                    <div>You have the following errors, please fix them and re-upload the sheet again.</div>
                    <br />
                    <ol>{errors.map((each, index) => <li key={index}>{each}</li>)}</ol>
                </div>
            ) : null}

            {onSubmit && <div style={{ marginTop: "70px" }}>
                <Tooltip title={!canCommit ? "You need employee upload (create) rights to onboard." : ""}>
                    <span>
                        <CommonButton
                            type="button"
                            text={"Submit"}
                            stylevariant="secondary1"
                            disabled={
                                !file?.name ||
                                employeesMapped?.length === 0 ||
                                hasErrors || loading || !canCommit
                            }
                            loading={loading}
                            onClick={() => {
                                onSubmit?.(employeesMapped);
                            }}
                        />
                    </span>
                </Tooltip>
            </div>}
            {isValidFile ? <div className={classes.successText}>Employees data validated successfully. No errors found.</div> : null}
        </div>
    </div>

}